import { render, staticRenderFns } from "./productInventory.vue?vue&type=template&id=34d82a68&"
import script from "./productInventory.vue?vue&type=script&lang=js&"
export * from "./productInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports